import { render, staticRenderFns } from "./FurtherQuestionsBanner.vue?vue&type=template&id=13dd9261&scoped=true"
import script from "./FurtherQuestionsBanner.vue?vue&type=script&lang=js"
export * from "./FurtherQuestionsBanner.vue?vue&type=script&lang=js"
import style0 from "./FurtherQuestionsBanner.vue?vue&type=style&index=0&id=13dd9261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd9261",
  null
  
)

export default component.exports